<template>
    <div class="dropdown-container" :class="{ 'has-items': showContainerBorder }">
        <div v-if="hasItems" class="dropdown-list">
            <div v-for="item in items" :key="item?.id" class="dropdown-item">
                <div class="info">
                    <div class="title">
                        {{ providerName(item) }}
                        <span v-if="item?.practice" class="verified">
                            <common-icon name="insure" size="tiny"></common-icon>
                            <span>{{ $t('elements.referrals.provider_search_card.verified') }}</span>
                        </span>
                    </div>

                    <div v-if="providerPracticeAddress(item)" class="sub">
                        {{ providerPracticeAddress(item) }}
                    </div>

                    <div class="phone-practice">
                        {{ providerPracticePhone(item) }}
                        {{ providerPracticeName(item) }}
                    </div>

                    <div class="tags">
                        <span class="tag">
                            {{ providerSpecialization(item?.specialization) }}
                        </span>
                    </div>
                </div>

                <button class="select-btn" @click="emitEvent({ name: 'provider-selected', payload: item })">
                    {{ $t('modals.patient_profile.profile.request.select') }}
                </button>
            </div>
        </div>

        <div v-else-if="loading" class="loading-spinner">
            <span>{{ $t('modals.import_contacts_modal.loading') }}</span>
            <loading-spin></loading-spin>
        </div>

        <div v-else-if="searched" class="empty-state">
            <common-icon name="building" size="extra-large"></common-icon>
            <p>{{ $t('modals.patient_profile.profile.request.no_providers_found') }}</p>
        </div>
    </div>
</template>

<script>
    import { Circle9 } from 'vue-loading-spinner'
    export default {
        components: {
            'loading-spin': Circle9,
        },
        props: {
            items: {
                type: Array,
                required: true,
            },
            searched: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            hasItems() {
                return this.items && this.items.length > 0
            },
            showContainerBorder() {
                return this.hasItems || this.loading || this.searched
            },
        },
        methods: {
            providerName(item) {
                return `${item.user.credential} ${item.firstName} ${item.lastName}`
            },
            providerPracticeName(item) {
                return item?.practice?.name
            },
            providerPracticeAddress(item) {
                if (!item?.addresses?.length) return ''

                const source = item.addresses.find((a) => a.addressType === 'Practice') || item.addresses[0]

                return [
                    source.firstLineAddress,
                    source.secondLineAddress,
                    source.cityNameNew || source.cityName,
                    source.stateName,
                    source.postalCodeNew || source.postalCode,
                ]
                    .filter(Boolean)
                    .join(', ')
            },
            providerPracticePhone(item) {
                const source = item.addresses.find((a) => a.addressType === 'Practice') || item.addresses[0]
                return source.telephoneNumber
            },
            providerSpecialization(value) {
                if (!value) return ''

                return value
                    .split('-')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .dropdown-container {
        background: #fff;
        border-radius: 8px;
        margin-top: 20px;
        width: 100%;
    }
    .dropdown-container.has-items {
        border: 1px solid #e5e7eb;
    }

    .dropdown-list {
        max-height: 220px;
        overflow-y: auto;
    }

    .dropdown-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .dropdown-item:hover {
        background: #f9fafb;
    }

    .title {
        font-weight: 500;
        color: black;
        font-size: 14px;
    }

    .sub {
        font-size: 12px;
        color: $color--txt-base;
        margin-top: 4px;
    }

    .phone-practice {
        font-size: 10px;
        color: $color--txt-base;
        margin-top: 4px;
    }

    .tags {
        margin-top: 6px;
    }

    .tag {
        display: inline-block;
        background: $color--bg-dashboard;
        color: black;
        font-size: 11px;
        padding: 3px 8px;
        border-radius: 12px;
        margin-right: 6px;
        font-weight: 500;
    }

    .select-btn {
        align-self: center;
        background: none;
        border: none;
        color: black;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        margin-right: 10px;
        padding: 6px 12px;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
    }

    .select-btn:hover {
        background: $color--bg-dashboard;
    }

    .verified {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-left: 8px;
        font-size: 10px;
        color: black;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 2px 8px;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 32px 16px;
        text-align: center;
        color: $color--txt-base-4;
    }

    .empty-state p {
        margin-top: 8px;
        font-size: 16px;
        color: $color--txt-base-8;
    }

    .loading-spinner {
        text-align: center;
        font-size: 16px;
        padding: 32px 16px;
        .spinner {
            margin: 0 auto;
            zoom: 150%;
        }
    }
</style>
